import React from "react";
import AddressFragment from "./AddressFragment";

export default function Address() {

    return (
        <div className="site-section">
            <div className="container">
                <div className="row">
                    <div><h2 className="section-heading"><strong>Адрес</strong></h2><p
                        className="mb-5">Автоплощадка на 180 машиномест, напротив МРЭО ГАИ, на месте бывшего авторынка Ждановичи.</p>
                    </div>
                </div>
                <AddressFragment/>
            </div>
        </div>

    );

}